import { Component } from '@angular/core';

@Component({
    selector: 'app-popup-container',
    templateUrl: './popup-container.component.html',
    styleUrls: ['./popup-container.component.scss'],
    standalone: false
})
export class PopupContainerComponent {

}
